<template>
  <div class="common-layout" v-loading="loading">
    <el-container>
      <el-aside width="12%" class="text_center">
        <h2 :style="{ color: role == 2 ? '#409eff' : '#FF7739' }">
          英语作文
          <br />
          智能批改系统
        </h2>
        <el-menu
          :default-active="active"
          class="el-menu-vertical-demo"
          :default-openeds="['1']"
          :active-text-color="role == 2 ? '#409eff' : '#FF7739'"
        >
          <div
            v-for="item in routerList"
            v-show="!item.hidden"
            :key="item.path"
          >
            <el-sub-menu index="1" v-if="item.children">
              <template #title>
                <el-icon>
                  <component :is="item.meta.icon" />
                </el-icon>
                <span>{{ item.meta.title }}</span>
              </template>
              <el-menu-item
                @click="link(e.name)"
                :index="e.path"
                v-for="e in item.children"
                :key="e"
                >{{ e.meta.title }}</el-menu-item
              >
            </el-sub-menu>
            <el-menu-item
              @click="link(item.name)"
              v-else
              v-show="!item.hidden"
              :index="item.path"
            >
              <el-icon>
                <component :is="item.meta.icon" />
              </el-icon>
              <span>{{ item.meta.title }}</span>
            </el-menu-item>
          </div>
          <el-menu-item @click="logout">
            <el-icon><Right /></el-icon>
            <span>退出登录</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container>
        <el-main>
          <!-- <el-header> -->
          <div class="header" v-if="role == 3">
            <span>机构编号：{{ school.catalog }}</span>
            <span
              ><el-icon><PriceTag /></el-icon>{{ school.name }}</span
            >
            <span
              ><el-icon><UserFilled /></el-icon>{{ school.mem_name }}（{{
                school.mem_phone
              }}）</span
            >
          </div>
          <!-- </el-header> -->
          <router-link :to="{ name: 'Home' }">
            <el-icon style="font-size: 26px; color: #b5b2b2" v-if="role == 2"
              ><HomeFilled
            /></el-icon>
          </router-link>

          <h2 v-if="role == 3">{{ title }}</h2>
          <router-view></router-view
        ></el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  setup() {
    const router = useRouter()
    const state = reactive({
      routerList: [],
      active: '/teacher/list',
      loading: false,
      role: 0,
      title: '',
      school: {},
    })
    watch(
      () => router,
      (newV, oldV) => {
        if (newV) {
          state.title = newV.currentRoute.value.meta.title
        }
      },
      { deep: true }
    )
    onMounted(() => {
      state.active = router.currentRoute.value.path
      state.role = location.href.indexOf('teacher') != -1 ? 2 : 3
      state.title = router.currentRoute.value.meta.title
      state.school = localStorage.getItem('school')
        ? JSON.parse(localStorage.getItem('school'))
        : {}

      console.log(state.active)
      getMenu()
    })
    const getMenu = () => {
      let list = router.options.routes
      state.routerList = []
      list.forEach(element => {
        if (element.children) {
          element.children.forEach(e => {
            if (e.meta.type == 1 && state.role == 2) {
              state.routerList.push(e)
            }
            if (e.meta.type == 2 && state.role == 3) {
              state.routerList.push(e)
            }
          })
        }
      })
    }

    const link = name => {
      router.push({
        name: name,
        params: { school: router.currentRoute.value.params.school },
      })
    }
    const logout = () => {
      ElMessageBox.confirm('确认要退出吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (state.role == 2) {
          router.push({
            name: 'Login',
            params: {
              type: 2,
              gid: JSON.parse(localStorage.getItem('class')).sys_school_sn,
            },
          })
          localStorage.removeItem('teacher')
          localStorage.removeItem('teacher_token')
          localStorage.removeItem('class')
        }
        if (state.role == 3) {
          router.push({
            name: 'Login',
            params: {
              type: 3,
              gid: JSON.parse(localStorage.getItem('school')).catalog,
            },
          })
          localStorage.removeItem('school')
          localStorage.removeItem('school_token')
        }
      })
    }

    return {
      ...toRefs(state),
      link,
      getMenu,
      logout,
    }
  },
}
</script>

<style lang="less" scoped>
.el-aside {
  height: 100%;
  position: fixed;
  .el-menu {
    border-right: none;
  }
}

.el-main {
  margin-left: 12%;
  background: #f3f4ff;
  min-height: 100vh;
  padding: 30px;
  padding-top: 20px;
}
.header {
  text-align: right;
  span {
    padding: 20px;
    font-size: 14px;
    color: #666;
  }
  .el-icon {
    vertical-align: middle;
  }
}
</style>
